import React from 'react'
import { Delimiter } from 'components/Delimiter'
import { Box, Grid } from 'components/Layout'
import { H4, H5, Text } from 'components/Typography'
import { SPACE, FONT_STACK, COLOR_INTENT } from 'Theme'

export const ParticipateSection: React.FC = () => (
  <Box>
    <H4 as="h2" textAlign="center" mb={SPACE.PX_40}>
      How to participate
    </H4>
    <Grid
      mb={{ MOBILE: SPACE.PX_20, TABLET: SPACE.PX_30 }}
      gridTemplateColumns={{ TABLET: '38% 62%' }}
    >
      <H5 as="h3" mb={{ MOBILE: SPACE.PX_20 }}>
        Book a Consultation
      </H5>
      <Text
        fontFamily={FONT_STACK.SERIF}
        color={COLOR_INTENT.EXPERT_DETAIL.PARTICIPATE_SECTION.TEXT}
      >
        Select a time/date and book your consultation. You&apos;ll be asked to
        summarize what you&apos;d like to discuss with your Expert.
      </Text>
    </Grid>
    <Delimiter />
    <Grid
      mt={SPACE.PX_30}
      mb={{ MOBILE: SPACE.PX_20, TABLET: SPACE.PX_30 }}
      gridTemplateColumns={{ TABLET: '38% 62%' }}
    >
      <H5 as="h3" mb={{ MOBILE: SPACE.PX_20 }}>
        Download Zoom
      </H5>
      <Text
        fontFamily={FONT_STACK.SERIF}
        color={COLOR_INTENT.EXPERT_DETAIL.PARTICIPATE_SECTION.TEXT}
      >
        Download Zoom for free on a desktop, tablet or mobile device. After
        booking, you&apos;ll receive an email with a link and details on how to
        join.
      </Text>
    </Grid>
    <Delimiter />
    <Grid mt={SPACE.PX_30} gridTemplateColumns={{ TABLET: '38% 62%' }}>
      <H5 as="h3" mb={{ MOBILE: SPACE.PX_20 }}>
        Join the video call
      </H5>
      <Text
        fontFamily={FONT_STACK.SERIF}
        color={COLOR_INTENT.EXPERT_DETAIL.PARTICIPATE_SECTION.TEXT}
      >
        Get personalized advice, support and guidance from a top Expert!
      </Text>
    </Grid>
  </Box>
)
